import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { AdminGuard } from './shared/guards/admin.guard';
import { AuthComponent } from './authentication/auth.component';
import { BaseComponent } from './base/base.component';
import { AboutPageOneComponent } from './base/about-page-one/about-page-one.component';
import { PricingPageComponent } from './base/pricing-page/pricing-page.component';
import { ContactPageComponent } from './base/contact-page/contact-page.component';
import { MyDashboardPageComponent } from './base/my-dashboard-page/my-dashboard-page.component';
import { PrivacyPolicyComponent } from './base/privacy-policy/privacy-policy.component';
import { GalleryPageComponent } from './base/gallery-page/gallery-page.component';
import { PaymentComponent } from './payment/payment.component';
import { SupportComponent } from './base/support/support.component';
import { GoogleReviewPageComponent } from './base/google-review-page/google-review-page.component';
import { UploadDataComponent } from './upload-data/upload-data.component';

export const routes: Routes = [


  {
    component: AuthComponent,
    path: 'authentication', loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    component: PaymentComponent,
    path: 'payment', loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule)
  },
  {
    component: BaseComponent,
    path: '', loadChildren: () => import('./base/base.module').then(m => m.BaseModule)
  },
  { path: 'about', component: AboutPageOneComponent },
  { path: 'pricing', component: PricingPageComponent },
  { path: 'contact', component: ContactPageComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'support', component: SupportComponent },
  { path: 'gallery', component: GalleryPageComponent },
  { path: 'my-account', component: MyDashboardPageComponent },
  { path: 'google-review', component: GoogleReviewPageComponent },
  { path: 'upload-data', component: UploadDataComponent },
  { path: 'update-missing-info', loadComponent: () => import('./update-missing-info/update-missing-info.component').then(c => c.UpdateMissingInfoComponent) },

  // {
  //   path: '**',
  //   redirectTo: 'error/404',
  // },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
